<template>
  <footer class="app-footer">
    <span v-if="versionInfo && versionInfo.frontend_version">v{{ versionInfo.frontend_version }}</span>
    <span v-else>loading...</span>
  </footer>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useVersionInfo } from '../composables/useVersionInfo'

const { versionInfo, loadVersionInfo } = useVersionInfo()

onMounted(async () => {
  await loadVersionInfo()
})
</script>

<style scoped>
.app-footer {
  width: 100%;
  text-align: center;
  padding: 1rem 0;
  color: var(--accent-text-color);
  /* background: var(--background); */
  box-shadow: 0em 0em 1em rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(var(--header-footer-blur-intensity));
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  font-size: 0.95rem;
  /* border-top: 1px solid var(--content-border-color); */
  position: sticky;
  bottom: 0;
  z-index: 10;
}
</style>
